import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value", "id", "checked"]
const _hoisted_2 = ["for"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "check-mark" }, null, -1)
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["options-input", _ctx.classes]),
    style: {"margin-left":"15px"}
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["option-input-wrapper", { 'is-checked': _ctx.isCheck(item.value) }]),
        key: item.value
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-check-input ms-2",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOptions) = $event)),
          value: item.value,
          id: item.value,
          checked: _ctx.isCheck(item.value)
        }, null, 8, _hoisted_1), [
          [_vModelCheckbox, _ctx.selectedOptions]
        ]),
        _createElementVNode("label", {
          class: "option-input",
          for: item.value
        }, [
          _hoisted_3,
          (item.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require(`@/assets/images/steps/${item.icon}.svg`),
                alt: item.label
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
        ], 8, _hoisted_2)
      ], 2))
    }), 128))
  ], 2))
}